import * as XLSX from 'xlsx';
import { formatDate } from '@/utils/formatters';

export const CSV_HEADERS = [
  'ID Lavorazione', 'Codice Sito', 'Nome Sito', 'Tipo di Intervento',
  'Ditta', 'Studio Progettazione', 'Comune', 'Provincia', 'Importo (EUR)',
  'Stato Lavorazione', 'Doc Caricati',
  'Data Inizio', 'Data Approvazione Documenti', 'Data Fine',
  'Note Rifiuto HQ', 'Categorie Rifiuto', 'Note Rifiuto Ditta', 'Errori Totali',
];

/** Converte una pratica in un array di valori per CSV, nello stesso ordine di CSV_HEADERS. */
export function practiceToRow(p) {
  return [
    p.id,
    p.codiceSito || '',
    p.nomeSito || '',
    p.tipologiaLavorazione || '',
    p.ditta || '',
    p.studioProgettazione || '',
    p.comune || '',
    p.provincia || '',
    p.importo ?? '',
    p.workflowStatus || '',
    p.docCaricati ? 'SI' : 'NO',
    formatDate(p.dataInizio),
    formatDate(p.dataApprovazioneDocumenti),
    formatDate(p.dataFine),
    p.noteRifiuto || '',
    Array.isArray(p.categorieRifiuto) ? p.categorieRifiuto.join(', ') : '',
    p.noteRifiutoDitta || '',
    // Totale rifiuti ricevuti dalla pratica (documenti + preventivo)
    (p.numeroErroriDocumenti || 0) + (p.numeroErroriPreventivo || 0),
  ];
}

export function exportToExcel(practices, filename = 'attivita_export.xlsx') {
  const data = [CSV_HEADERS, ...practices.map(practiceToRow)];
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Auto-width colonne basata sul contenuto
  ws['!cols'] = CSV_HEADERS.map((h, i) => {
    const maxLen = Math.max(h.length, ...practices.map((p) => String(practiceToRow(p)[i] ?? '').length));
    return { wch: Math.min(maxLen + 2, 40) };
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Attività');
  XLSX.writeFile(wb, filename);
}

export function exportToCSV(practices, filename = 'attivita_export.csv') {
  const rows = practices.map(practiceToRow);

  const escapeCsv = (v) => {
    const s = String(v);
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const csv = [CSV_HEADERS.map(escapeCsv).join(','), ...rows.map((r) => r.map(escapeCsv).join(','))].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
